import { ReactNode } from 'react';
import styles from './footer.module.css';

export interface FooterProps {
  children: ReactNode;
}

const Footer = (props: FooterProps) => (
  <div className={styles.footer}>
    <div className={styles.footerContent}>{props.children}</div>
    <div className={styles.footerDecoration} />
  </div>
);

export default Footer;
